@let totalSteps = steps().length;

<div data-text-wrapper>
  <div data-title>{{ steps()[currentStepNumber()].name }}</div>
  <div data-subtitle>
      @if (currentStepNumber() >= totalSteps) {
        Completed
      } @else {
        Step {{ currentStepNumber() + 1 }} of {{ totalSteps }}
      }
    </div>
</div>
<div data-stepper-track>
  @for (item of steps(); track item.name) {
    @let status = $index < currentStepNumber() ? 'complete' : $index === currentStepNumber() ? 'current' : 'incomplete';
    @if (!$first) {
      <span aria-hidden="true" data-bar [attr.data-status]="status"></span>
    }
    <span [attr.data-status]="status"
          [attr.data-step]="$index"
          (click)="item.touchLink?.onClick?.()">
      <span data-circle>
        @if (status === 'current') {
          <span>{{ $index + 1 }}</span>
        }
        @if (status === 'complete') {
          <bspk-icon name="Check" />
        }
        </span>
    </span>
  }
</div>
